module.exports = __webpack_public_path__ + "9fcae64fe7ab758ea14143f2764e57af.png";